import React, { Component } from 'react';
import FormLabel from '@material-ui/core/FormLabel';
import FormGroup from '@material-ui/core/FormGroup';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import _ from 'lodash';

import CheckBox from '../Checkbox/Checkbox';

function getDefaultListValue(listValue) {
  return listValue || [];
}

class CheckboxGroup extends Component {
  constructor(props) {
    super(props);
    const { error } = this.props;
    const checked = getDefaultListValue(props.checked);
    this.state = {
      checked,
      error: error || null
    };
  }

  componentDidUpdate(prevProps) {
    const prevChecked = prevProps.checked;
    const { checked: newChecked, error } = this.props;
    if (_.xor(prevChecked, newChecked).length !== 0) {
      const checked = getDefaultListValue(newChecked);
      // TODO: Figure this next issue out as it's a big code smell...
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        checked,
        error
      });
    }
  }

  handleChange = value => event => {
    const { t, onChange, inputValidation, onValidationError } = this.props;
    const { checked } = this.state;
    const copy = [...checked];

    if (event.target.checked) {
      copy.push(value);
    } else {
      const index = copy.indexOf(value);
      copy.splice(index, 1);
    }

    let errorObj = null;
    const numChecked = copy.length;
    errorObj = inputValidation(numChecked);
    if (errorObj) {
      onValidationError(copy, errorObj);
    } else {
      onChange(copy);
    }
    const error = errorObj ? t(errorObj.key, { ...errorObj.args }) : null;
    this.setState({ error, checked: copy });
  };

  /**
   * row
   * checked: []
   * intermediate: []
   * options: [{
   *   color
   *   value
   *   label
   * }]
   */
  render() {
    const { checked, error } = this.state;
    const { options, intermediate, disabled, row, title } = this.props;
    const checkboxes = options.map(option => {
      const isChecked = checked.includes(option.value);
      const isIntermediate = intermediate.includes(option.value);
      return (
        <CheckBox
          key={option.value}
          checked={isChecked}
          disabled={disabled}
          indeterminate={isChecked ? false : isIntermediate}
          value={String(option.value)}
          onChange={this.handleChange(option.value)}
          label={option.label}
          color={option.color}
        />
      );
    });

    return (
      <>
        <FormControl>
          {title && <FormLabel>{title}</FormLabel>}
          <FormGroup row={row}>{checkboxes}</FormGroup>
        </FormControl>
        {error && <FormHelperText error>{error}</FormHelperText>}
      </>
    );
  }
}

CheckboxGroup.defaultProps = {
  t: k => k,
  options: [],
  checked: [],
  intermediate: [],
  inputValidation: () => null,
  onValidationError: e => e
};

export default CheckboxGroup;
